var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "before-close": _vm.handleClose,
        title: "查看示例",
        visible: _vm.dialogVisible,
        width: Number(_vm.width + 30) + "px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "imgBox", style: { width: _vm.width + "px" } }, [
        _c("img", { attrs: { src: _vm.url } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }